// extracted by mini-css-extract-plugin
export default {"pageWrapper":"page-wrapper_pageWrapper__Rsnho","container":"page-wrapper_container__ot2qL"};